import { Translation } from '../types/translations';

const en: Translation = {
    companies: {
        title: 'Companies',
        filters: 'Filters',
        activeFilters: 'active',
        reset: 'reset',
        listOfMatches: 'List Of Matches',
        loadMore: 'Load more companies',
        searchByIdVat: 'Search By ID/VAT',
        allSizes: 'All Sizes',
        allPriceLists: 'All Price Lists',
        settings: 'Table settings',
    },
    errors: {
        companyNotFound: 'Company not found',
        somethingWentWrong: 'Something went wrong. Please try again later or contact support.',
    },
    generic: {
        cancel: 'Cancel',
        close: 'Close',
        loading: 'Loading',
        no: 'No',
        ok: 'OK',
        yes: 'Yes',
    },
    login: {
        changePassword: 'Change password',
        confirmPassword: 'Confirm new password',
        currentPassword: 'Current password',
        email: 'Email',
        emailCheck: 'Please enter a valid email',
        forgottenPwd: 'Forgot password?',
        loginError: 'Login failed. Please check your credentials.',
        newPassword: 'New password',
        noAccount: "Don't have an account?",
        password: 'Password',
        passwordChanged: 'Password has been changed successfully',
        passwordCheck: 'Please enter a password',
        passwordNotChanged: 'Password could not be changed. Please check the current password.',
        passwordsNotMatch: 'Passwords do not match',
        remember_me: 'Remember me',
        signIn: 'Sign in',
        signUpNow: 'Sign up now',
        unknownError: 'Login failed. Please check your credentials or try again later.',
        logoAlt: 'Bindfind logo',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
    },
    menu: {
        about: 'About',
        analytics: 'Analytics',
        codebooks: 'Codebooks',
        companies: 'Companies',
        contact: 'Contact',
        dashboard: 'Dashboard',
        help: 'Help',
        home: 'Home',
        profile: 'Profile',
        settings: 'Settings',
    },
    tour: {
        generic: {
            next: 'Next',
            previous: 'Previous',
            finish: 'Finish',
        },
        filters: {
            name: 'Filters',
            description:
                'Use filters to narrow down the list of companies. You can filter by name, status, and other criteria.',
        },
        tableSettings: {
            name: 'Table Settings',
            description: 'Here you can adjust the table settings, such as columns and their order.',
        },
        columnReorder: {
            name: 'Column Reorder',
            description:
                'Drag and drop columns to change their order. This setting will be saved and used the next time you load the table.',
        },
    },
    mfa: {
        backupCode: 'Backup code',
        codeEmpty: 'Please enter code',
        disable: 'Disable',
        disabled: 'Multi-factor authentication has been disabled.',
        disableTitle: 'Disable MFA',
        enable: 'Enable',
        enabled: 'Multi-factor authentication has been enabled.',
        enableText1: 'Multi-factor authentication has been enabled. To finish setup please follow steps below.',
        enableText2: '1. Open an authenticator app of your choice',
        enableText3: '2. Scan QR code or manually input the shared key',
        enableText4: '3. Verify code generated by the authenticator',
        enableText5:
            'Here is a list of your one-time use backup codes. Please save them somewhere safe, you will not be able to see them again.',
        enableTitle: 'Enable MFA',
        enterCode: 'Enter verification code generated by your authenticator app',
        invalidCode: 'Invalid verification code',
        mfa: 'Multi-factor authentication',
        sureToDisable: 'Are you sure you want to disable MFA?',
        twoFactorTitle: 'Two-Factor Authentication',
        useAuthenticator: 'Use authenticator verification code',
        useBackupCode: 'Do not have access? Use one-time backup code instead',
        verificationCode: 'Verification code',
        verify: 'Verify',
        verifyAndEnable: 'Verify and enable MFA',
    },
    selectedCompany: {
        branches: {
            addBranch: 'Add branch',
            companyBranches: 'Company branches',
            contactPersons: 'Contact persons + contacts',
        },
        branchDetail: {
            branchDetail: 'Branch detail',
            keyContactPresent: 'Key contact present',
        },
        companyDetail: {
            addComp: 'Add company',
            central: 'Central',
            compDetail: 'Company detail',
            dic: 'DIC',
            fieldIds: 'Field',
            ic: 'IC',
            noBranches: 'No branches found',
            numofemployees: 'employees',
            openGoogleMap: 'Open in Google Maps',
            priceListId: 'Price list',
            retry: 'Retry',
        },
        contacts: {
            contactDetail: 'Contact detail',
            position: 'Position',
            verified: 'Verified contact',
        },
        generic: {
            email: 'Email',
            fav: 'Favorite',
            inactive: 'Inactive company',
            lastContact: 'Last contact',
            nextContact: 'Next contact',
            note: 'Note',
            phone: 'Phone',
            referentId: 'Referent',
            state: 'State',
            statutId: 'Status',
            unfav: 'Unfavorite',
            www: 'Web',
        },
    },
    filters: {
        apply: 'Apply',
        hide: 'Hide',
        remove: 'Remove',
    },
    sidebar: {
        banner: 'Ad space',
        text: 'This is an ad space. You can use it to display some information or promotional messages.',
    },
    tables: {
        detail: {
            loadMore: 'Load More',
            noMoreRecords: 'No more records to load',
        },
        branchesTable: {
            contacted: 'Contacted',
            keyContact: 'Key contact',
        },
        companyTable: {
            address: 'Address',
            addressDetails: 'Address Details',
            addressDetails2: 'Additional Address Details',
            capitalAmount: 'Capital Amount',
            cityDistrict: 'City District',
            county: 'County',
            countryId: 'Country ID',
            createdById: 'Created By (ID)',
            createdDate: 'Created Date',
            district: 'District',
            email: 'Email',
            establishedDate: 'Established Date',
            ic: 'IC',
            id: 'ID',
            imported: 'Imported',
            legalFormId: 'Legal Form ID',
            mainLanguageId: 'Main Language ID',
            mainScopeId: 'Main Scope ID',
            mainSourceUrl: 'Main Source URL',
            municipality: 'Municipality',
            name: 'Name',
            otherInfo: 'Other Information',
            registrationId: 'Registration ID',
            registrationLastChange: 'Last Registration Change',
            size: 'Size',
            status: 'Status',
            street: 'Street',
            terminationDate: 'Termination Date',
            terminationType: 'Termination Type',
            useIc: 'Use IC',
            validationScore: 'Validation Score',
            vat: 'VAT',
            village: 'Village',
            website: 'Website',
            zipCode: 'ZIP Code',
        },
    },
    user: {
        email: 'Email',
        middleName: 'Middle name',
        name: 'Name',
        surname: 'Surname',
    },
    enums: {
        companyLegalForm: {
            sro: 'Limited Liability Company',
            as: 'Joint Stock Company',
            gmbh: 'Gesellschaft mit beschränkter Haftung',
            ag: 'Aktiengesellschaft',
            sarl: 'Société à responsabilité limitée',
            sa: 'Société anonyme',
            ltd: 'Private Limited Company',
            llc: 'Limited Liability Company',
            inc: 'Incorporated',
            corp: 'Corporation',
            srl: 'Società a responsabilità limitata',
            sl: 'Sociedad limitada',
            srl_it: 'Società a responsabilità limitata (Italy)',
            spa: 'Società per azioni',
            kft: 'Korlátolt felelősségű társaság',
            nv: 'Naamloze vennootschap',
            ab: 'Aktiebolag',
            asa: 'Allmennaksjeselskap',
            as_ee: 'Aktsiaselts',
            ou: 'Osaühing',
            ooo: 'Obshchestvo s ogranichennoi otvetstvennostyu',
            tov: 'Tovarishchestvo s ogranichennoi otvetstvennostyu',
            vos: 'General Partnership',
            ks: 'Limited Partnership',
            lp: 'Limited Partnership',
            llp: 'Limited Liability Partnership',
            sole: 'Sole Proprietorship',
            coop: 'Cooperative',
            foundation: 'Foundation',
            association: 'Association',
            soe: 'State Enterprise',
            not_specified: 'Not Specified',
        },
        companyLegalFormType: {
            limited_liability: 'Limited Liability',
            joint_stock: 'Joint Stock',
            partnership: 'Partnership',
            sole_proprietorship: 'Sole Proprietorship',
            cooperative: 'Cooperative',
            foundation: 'Foundation',
            association: 'Association',
            state_enterprise: 'State Enterprise',
            branch: 'Branch',
            insurance: 'Insurance',
            other: 'Other',
        },
        companyScopeType: {
            administration_accounting: 'Administration and Accounting',
            safety_rescue_fire_ohs: 'Safety and Rescue (Fire, OHS)',
            workshop_hobby_metal_wood: 'Workshop and Hobby (Metal, Wood)',
            rail_transport: 'Rail Transport',
            air_transport: 'Air Transport',
            land_transport: 'Land Transport',
            water_transport: 'Water Transport',
            transport_services_infrastructure: 'Transport, Services and Infrastructure',
            drugstore_hygiene: 'Drugstore and Hygiene',
            ecology_environment: 'Ecology and Environment',
            electrical_equipment: 'Electrical Equipment',
            electrical_installation: 'Electrical Installation',
            electrical_appliances: 'Electrical Appliances',
            energy_heating_power: 'Energy, Heating and Power',
            finance_leasing_insurance: 'Finance, Leasing and Insurance',
            music_musical_instruments: 'Music and Musical Instruments',
            interior_furnishings: 'Interior and Furnishings',
            it_hardware_electronics: 'IT, Hardware and Electronics',
            it_software_services: 'IT, Software and Services',
            office_supplies_paper: 'Office Supplies and Paper',
            jewelry_watches_clocks: 'Jewelry, Watches and Clocks',
            landscape_gardening_pet_supplies: 'Landscape, Gardening and Pet Supplies',
            forestry_logging: 'Forestry and Logging',
            materials_metals_chemistry: 'Materials, Metals and Chemistry',
            sea_fishing: 'Sea and Fishing',
            hunting_gamekeeping: 'Hunting and Gamekeeping',
            unclassified: 'Unclassified',
            trade_advertising_sales_support: 'Trade, Advertising and Sales Support',
            waste_recycling: 'Waste and Recycling',
            personal_care_spa: 'Personal Care and Spa',
            hospitality_accommodation: 'Hospitality and Accommodation',
            food_beverages_tobacco: 'Food, Beverages and Tobacco',
            precision_instruments_optics: 'Precision Instruments and Optics',
            real_estate_property: 'Real Estate and Property',
            distribution_water_electricity_gas: 'Distribution (Water, Electricity, Gas)',
            storage: 'Storage and Handling',
            foundry_metallurgy: 'Foundry and Metallurgy',
            justice_courts_law: 'Justice, Courts and Law',
            construction_architecture_engineering: 'Construction, Architecture and Engineering',
            machinery_equipment: 'Machinery and Equipment',
            machinery_equipment_parts: 'Machinery and Equipment Parts',
            machinery_equipment_work: 'Machinery and Equipment Work',
            telecommunications_media: 'Telecommunications and Media',
            textiles_clothing_footwear_leather: 'Textiles, Clothing, Footwear and Leather',
            mining_quarries: 'Mining and Quarries',
            cleaning_sanitation: 'Cleaning and Sanitation',
            science_research_development: 'Science, Research and Development',
            public_social_services: 'Public and Social Services',
            military_industry: 'Military Industry',
            publishing_printing_photography: 'Publishing, Printing and Photography',
            education_training: 'Education and Training',
            ventilation_heating_plumbing: 'Ventilation, Heating and Plumbing',
            entertainment_sports_recreation: 'Entertainment, Sports and Recreation',
            healthcare_medical_services: 'Healthcare and Medical Services',
            agriculture_plants: 'Agriculture and Plants',
            agriculture_animals: 'Agriculture and Animals',
            agriculture_mixed: 'Agriculture, Mixed',
            undefined: 'Undefined / Empty',
        },
        companySize: {
            a: 'A',
            b: 'B',
            c: 'C',
            d: 'D',
            e: 'E',
            f: 'F',
        },
        companyStatus: {
            active: 'Active',
            active_validated: 'Active Validated',
            blocked: 'Blocked',
            blocked_auto: 'Auto Blocked',
            deleted: 'Deleted',
        },
        companyTerminationType: {
            bankrupt: 'Bankrupt',
            terminated: 'Terminated',
        },
        contactStatus: {
            not_validated: 'Not Validated',
            validated: 'Validated',
            hidden: 'Hidden',
            deleted: 'Deleted',
        },
        contactType: {
            0: 'Email',
            1: 'Phone',
        },
        country: {
            Czechia: 'Czechia',
        },
        personStatus: {
            gdpr_inactive: 'Inactive (GDPR)',
            active: 'Active',
            active_validated: 'Active Validated',
            hidden: 'Hidden',
            deleted: 'Deleted',
        },
        userRole: {
            guest: 'Guest',
            user: 'User',
            company_administrator: 'Company Administrator',
            company_owner: 'Company Owner',
            admin: 'Administrator',
            superadmin: 'Superadmin',
        },
        userStatus: {
            active: 'Active',
            inactive: 'Inactive',
            active_validated: 'Active Validated',
            blocked: 'Blocked',
            blocked_auto: 'Auto Blocked',
            hidden: 'Hidden',
            deleted: 'Deleted',
        },
    },
};

export default en;
